import { useEffect, useState, useMemo, useCallback } from 'react';
import { createFileTree, ToggleFileTree } from 'react-toggle-file-tree';
import * as stylex from '@stylexjs/stylex';
import { styles } from '../styles';
import { deleteBlobByKey, getAllSavedBlobs } from '../helpers/cache';
import { getFilesFromZipBlob } from '../helpers/unzipProfiles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getFileExt = file => file.name.slice(file.name.lastIndexOf('.'));
const getRawFiles = (fileList, localPath, ext) => fileList.filter(f => localPath === f.localPath && getFileExt(f.file) === ext).map(f => f.file);
export const FileTree = _ref => {
  let {
    loadProfiles,
    loadIrs,
    loading,
    refetch
  } = _ref;
  const [fileList, setFileList] = useState([]);
  const [selectedDirectory, setSelectedDirectory] = useState();
  const handleFileClick = e => {
    if (loading) {
      return;
    }
    const {
      file,
      localPath,
      blobKey,
      blobTitle,
      blob
    } = e;
    setSelectedDirectory({
      key: blobKey,
      title: blobTitle || localPath.slice(1),
      blob
    });
    const ext = getFileExt(file); // load all files of that type, just like in NAM plugin
    const files = getRawFiles(fileList, localPath, ext);
    const index = files.findIndex(_ref2 => {
      let {
        name
      } = _ref2;
      return name === file.name;
    });
    if (ext === '.nam') {
      loadProfiles(files, index);
    } else if (ext === '.wav') {
      loadIrs(files, index);
    }
  };
  const handleDirectoryClick = e => {
    setSelectedDirectory({
      key: e.value.files[0].blobKey,
      title: e.key,
      blob: e.value.files[0].blob
    });
  };
  const readCacheToList = useCallback(async () => {
    const cachedBlobs = await getAllSavedBlobs();
    const newList = [];
    if (!cachedBlobs) {
      return;
    }
    const promises = cachedBlobs.map(_ref3 => {
      let {
        profilesUrl,
        profilesBlob,
        title
      } = _ref3;
      return getFilesFromZipBlob(profilesBlob).then(files => {
        if (files.length) {
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            newList.push({
              file,
              fileName: file.name,
              localPath: title ? "/".concat(title) : "".concat(profilesUrl.slice(profilesUrl.lastIndexOf('/'))),
              blobKey: profilesUrl,
              // blob of the directory zip it belongs to
              blob: profilesBlob,
              blobTitle: title
            });
          }
        }
      });
    });
    await Promise.all(promises);
    setFileList(newList);
  }, []);
  useEffect(() => {
    if (!refetch) {
      return;
    }
    readCacheToList();
  }, [readCacheToList, refetch]);
  const fileTree = useMemo(() => createFileTree(fileList), [fileList]);
  const deleteCachedBlob = () => {
    if (window.confirm("Are you sure? This will remove the entire selected directory (".concat(selectedDirectory.title, ") from the cache"))) {
      deleteBlobByKey(selectedDirectory.key).then(readCacheToList);
    }
  };
  if (!fileList.length) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    ...stylex.props(styles.fileTreeWrapper),
    children: [/*#__PURE__*/_jsxs("p", {
      children: ["Downloaded profiles ", loading && /*#__PURE__*/_jsx("span", {
        children: "(loading...)"
      })]
    }), /*#__PURE__*/_jsxs("p", {
      children: ["Selected directory: ", selectedDirectory && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          ...stylex.props(styles.selectedDirectory),
          children: selectedDirectory.title
        }), "\xA0", /*#__PURE__*/_jsx("button", {
          onClick: deleteCachedBlob,
          children: "Delete"
        }), "\xA0", /*#__PURE__*/_jsx("a", {
          download: "".concat(selectedDirectory.title, ".zip"),
          href: window.URL.createObjectURL(new Blob([selectedDirectory.blob]), {
            type: 'application/zip'
          }),
          children: /*#__PURE__*/_jsx("button", {
            children: "Download"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      ...stylex.props(styles.fileTree),
      children: /*#__PURE__*/_jsx("div", {
        ...stylex.props(styles.fileTreeContent, loading && styles.fileTreeLoading),
        children: /*#__PURE__*/_jsx(ToggleFileTree, {
          list: fileTree,
          handleFileClick: handleFileClick,
          handleDirectoryClick: handleDirectoryClick
        })
      })
    })]
  });
};